import React, { useEffect, useState } from "react";
import Select from "react-select";
import { UrlWs } from "../../utils/Global";

async function cargar(usarNombre) {
  const url = UrlWs + "/municipal-management/list";

  if (localStorage.getItem(url) != null) {
    return JSON.parse(localStorage.getItem(url));
  }

  const opciones = await fetch(url, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  })
    .then((response) => {
      if (response.status == 400) {
        return [];
      } else {
        return response.json();
      }
    })
    .then((datos) => {
      datos.unshift({
        id_Dmunicipal: "null",
        nameDmunicipal: "Seleccione una dirección",
      });
      const opciones = datos.map((d, index) => {
        return {
          value: usarNombre ? d.nameDmunicipal : d.id_Dmunicipal,
          label: d.nameDmunicipal,
        };
      });
      return opciones;
    });

  localStorage.setItem(url, JSON.stringify(opciones));
  return opciones;
}

export const Direcciones = ({
  updateValue,
  handleChange = null,
  nuevoValue,
  disabled,
  usarNombre = false,
}) => {
  const [actualizarProceso, setActualizarProceso] = useState(true);
  const [datos, setDatos] = useState(null);
  const [cargandoDatos, setCargandoDatos] = useState(false);
  const [error, setError] = useState("");
  const [direccion, setDireccion] = useState(null);

  useEffect(() => {
    if (actualizarProceso && cargandoDatos === false) {
      setCargandoDatos(true);
      setActualizarProceso(false);
      console.log("USARNIMBRE ", usarNombre);
      cargar(usarNombre).then((opciones) => {
        console.log("USARNIMBRE ", opciones);
        setCargandoDatos(false);
        setDireccion(opciones[0]);
        setDatos(opciones);
        if (
          nuevoValue != null &&
          direccion != null &&
          nuevoValue != direccion.value
        ) {
          const opcion = datos.find((d) => d.value == nuevoValue);
          if (opcion != null) {
            setDireccion(opcion);
          } else {
            updateValue("direccion", opciones[0].value);
          }
        } else {
          updateValue("direccion", opciones[0].value);
        }
      });
    }
  }, []);

  useEffect(() => {
    if (datos != null && nuevoValue != null) {
      const opcion = datos.find((d) => d.value == nuevoValue);
      if (opcion != null) {
        setDireccion(opcion);
      }
    }
  }, [nuevoValue]);

  return (
    <Select
      isDisabled={disabled}
      value={direccion}
      name="direccion"
      onChange={(choice) => {
        console.log("Updaet choice " + choice.value);
        updateValue("direccion", choice.value);
        setDireccion(choice);
        if (handleChange != null) {
          handleChange(choice.value);
        }
      }}
      placeholder="Seleccione"
      options={
        actualizarProceso || cargandoDatos
          ? [{ value: "", label: "Cargando datos..." }]
          : datos
      }
    />
  );
};
